import {connect} from 'react-redux';
import {push} from 'react-router-redux';

import AnmeldungAbgeschlossen from './AnmeldungAbgeschlossen';

function mapDispatchToProps(dispatch, ownProps) {
  return {
    onNext: () => {
      dispatch(push(ownProps.nextRoute));
    }
  }
}

export default connect(
  undefined,
  mapDispatchToProps
)(AnmeldungAbgeschlossen)



// WEBPACK FOOTER //
// ./src/components/anmeldung-abgeschlossen/AnmeldungAbgeschlossenComponent.js